import * as React from 'react';
import { BreadcrumbsItem, Page, PageHeader } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { SaveAndPublishButton } from '../save-and-publish/save-and-publish.container';
import { BreadcrumbsComponent } from './breadcrumbs.component';
import { IPage, PageRoute } from '@src/types';
import { INavigationActions } from '@src/context/navigation-store/navigation-listener';
import { NavigationPrompt } from './navigation-prompter';

export interface Props extends InjectedTranslateProps, Pick<INavigationActions, 'navigateToRoute'> {
  pageData: IPage;
  breadcrumbItems: BreadcrumbsItem[];
}

class Component extends React.PureComponent<Props> {
  onBackClicked = () => {
    const { navigateToRoute, breadcrumbItems } = this.props;
    if (this.hasBackRoute()) {
      navigateToRoute(breadcrumbItems[breadcrumbItems.length - 2].id as PageRoute);
    }
  };

  hasBackRoute = () => this.props.breadcrumbItems.length > 1;

  render() {
    const { t, pageData } = this.props;

    return (
      <Page dataHook={DataHooks.Page}>
        <PageHeader
          title={t(pageData.titleKey || '')}
          subtitle={pageData.subtitleComponent}
          dataHook={DataHooks.PageHeader}
          showBackButton={this.hasBackRoute()}
          onBackClicked={this.onBackClicked}
          actionsBar={pageData.hasSaveAction ? <SaveAndPublishButton /> : null}
          breadcrumbs={<BreadcrumbsComponent />}
        />
        <Page.Content>
          {this.props.children}
          <NavigationPrompt />
        </Page.Content>
      </Page>
    );
  }
}

export const InnerPageComponent = translate()(Component);
